import React from 'react';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import { formatImageAuto } from '../../../../../../base/publicMethod/index';
import ShortRelate from '../shortRelate';
import styles from './index.css';
import ShortHead from '../shortHead';
import ShortFooter from '../shortFooter';
import ShortPlayer from '../shortPlayer';

const isVideoShare =
    (typeof window === 'object' && window.allData && window.allData.docData && window.allData.docData.isVideoShare) ||
    false;

class ShortVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        let relateData = {};
        const gotoUrl =
            (content.url && isVideoShare
                ? `https://ishare.ifeng.com/c/vs/${content.link.weburl.split('/').pop()}`
                : content.url) || '';
        const postImg =
            (content.thumbnails &&
                content.thumbnails.image &&
                content.thumbnails.image[0] &&
                content.thumbnails.image[0].url &&
                formatImageAuto(content.thumbnails.image[0].url.replace(/\.webp|_webp/g, ''), 750, 388)) ||
            '';

        if (content.subItem) {
            relateData = {
                type: content.subItem.type === 'phvideo' ? 'video' : 'doc',
                url:
                    (content.subItem.link && isVideoShare
                        ? `https://ishare.ifeng.com/c/vs/${content.subItem.link.weburl.split('/').pop()}`
                        : content.subItem.link.weburl) || '',
                logo: (content.subItem.subscribe && content.subItem.subscribe.logo) || '',
                sourceFrom: (content.subItem.subscribe && content.subItem.subscribe.catename) || '',
                title: content.subItem.intro || '',
                image: (content.subItem.thumbnail && content.subItem.thumbnail.replace(/\.webp|_webp/g, '')) || '',
                duration: (content.subItem.phvideo && content.subItem.phvideo && content.subItem.phvideo.length) || '',
            };
        }

        return (
            <div
                className={`${styles.shortRelate} ${content.noTopLine ? styles.noTopLine : ''} ${
                    content.noBottomLine ? styles.noBottomLine : ''
                }`}>
                <ShortHead content={content} />
                <a
                    href={gotoUrl}
                    className={styles.shortRelateTitle}
                    dangerouslySetInnerHTML={{ __html: content.summary && content.summary.replace(/\n/g, '<br />') }}
                />
                {/* {relateData.title && <div className={styles.shortRelateBox}><ShortRelate content={relateData} /></div>} */}
                {/* {postImg && <a href={gotoUrl} className={styles.shortRelateBox}>
                                <div className={styles.shortRelateVideo}>
                                    <LazyImg
                                        className={styles.shortRelateVideoPic}
                                        placeholder="data:image/svg+xml;utf8,<svg version=&quot;1.1&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;345&quot; height=&quot;194&quot;><rect x=&quot;0&quot; y=&quot;0&quot; width=&quot;349&quot; height=&quot;196&quot; fill=&quot;%23f2f2f2&quot;/></svg>"
                                        src={postImg}
                                    />
                                    <span className={styles.shortRelateVideoIcon} />
                                </div>
                        </a>
                    } */}
                <ShortPlayer content={content} />
                <ShortFooter content={content} />
            </div>
        );
    }
}

export default ShortVideo;
